import Api from 'src/api/Base'

class GetSpaceTypeById extends Api {
  requestUrl = `/api/spaceType/${this.getParams().id}`
}

export default GetSpaceTypeById
